import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { Pressable } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

type DraftCommentBoxProps = {
	testId?: string;
	expandPageCommentEditorHandler: () => void;
};

const styles = cssMap({
	draftComment: {
		width: '100%',
		height: '36px',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		padding: token('space.100'),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		color: token('color.text.subtlest'),
		backgroundColor: token('color.background.input'),
	},
});

const i18n = defineMessages({
	unsavedDraftComment: {
		id: 'object-comments.draft-comment-box.text',
		defaultMessage: 'Comment in progress - select to continue',
		description: 'Text message for unsaved draft page comment',
	},
});

export const DraftCommentBox: React.FC<DraftCommentBoxProps> = ({
	testId = 'draft-comment-box',
	expandPageCommentEditorHandler,
}) => {
	const { formatMessage } = useIntl();

	return (
		<Pressable xcss={styles.draftComment} testId={testId} onClick={expandPageCommentEditorHandler}>
			{formatMessage(i18n.unsavedDraftComment)}
		</Pressable>
	);
};
